import { render } from "./UserRegister.vue?vue&type=template&id=2f079b46&scoped=true&ts=true"
import script from "./UserRegister.vue?vue&type=script&lang=ts"
export * from "./UserRegister.vue?vue&type=script&lang=ts"

import "./UserRegister.vue?vue&type=style&index=0&id=2f079b46&scoped=true&lang=css"

import exportComponent from "C:\\Users\\hori_taiki\\Desktop\\小野写真館\\環境構築\\point-front-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f079b46"]])

export default __exports__